'use strict'

export default [
  {
    name:"reason",
    fields: [
      { name: "name" },
      { name: "objectives", height:3 },
      { name: "deliverables", height:3 },
      { name: "outcomes", height:3 }
    ]
  },
  {
    name:"surroundings",
    fields: [
      {name: "context", height:3},
      {name: "stakeholders", height:3}
    ]
  },
  {
    name:"dependencies",
    fields: [
      {name: "timing", height:3},
      {name: "resources", height:3},
      {name: "tradeOffs", height:3}
    ]
  },
  {
    name:"relationship",
    fields: [
      {name: "relations", height:3}
    ]
  }
];



// WEBPACK FOOTER //
// ./views/extremeProject/formDefinition.js